import '../styles/global.css';
import React  from 'react';

export default function FotoUpload({ foto, nombre, onUpload, editable = false }) {
  const inputRef = React.useRef();

  return (
    <div
      onClick={() => (!foto || editable) && inputRef.current.click()}
      className={`espacio-foto ${foto ? 'con-foto' : ''}`}
      style={editable ? { cursor: 'pointer' } : {}}
      title={!foto ? 'Clic para subir foto' : editable ? 'Clic para cambiar foto' : ''}
    >
      {foto
        ? <img src={foto} alt={nombre} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        : <span style={{ fontSize: 11, color: '#aaa', textAlign: 'center', lineHeight: 1.3 }}>
            {nombre?.charAt(0).toUpperCase() ?? '📷'}
          </span>
      }
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={(e) => {
          const archivo = e.target.files[0];
          if (archivo) onUpload(archivo);
        }}
      />
    </div>
  );
}